module.exports = __webpack_public_path__ + "img/headerlogo.d8b5209f.svg";